module.exports = __webpack_public_path__ + "static/media/file.d301cd0e.svg";